import classNames from "classnames";
import {
  DescriptionListTBody,
  DescriptionListTd,
  DescriptionListTh,
  DescriptionListTr,
  DescriptionListTrExpander,
  DotsDescriptionListTable,
} from "dots-ui/components/dotsDescriptionList";
import { IEditableListRowState } from "../../types";
import { AvisEditableListHeaderValue } from "../AvisEditableListHeaderValue";
import { IAvisEditableListRowClassProps } from "../AvisEditableListRowClass";
import { AvisEditableListRowField } from "../AvisEditableListRowField";
import { AvisEditableListRowActions } from "../actions/AvisEditableListRowActions";

interface IAvisEditableListDescriptionListRowProps<
  P extends IEditableListRowState,
> extends IAvisEditableListRowClassProps<P> {
  rowClass: string;
}
export function AvisEditableListDescriptionListRow<
  P extends IEditableListRowState,
>(props: Readonly<IAvisEditableListDescriptionListRowProps<P>>): JSX.Element {
  const { rowClass, disabled, fields } = props;

  const rowClassValue = classNames(rowClass, "col-12");
  const renderRow = () => {
    const actionsRow = (
      <DescriptionListTr key={"actions"}>
        {disabled ? null : (
          <>
            <DescriptionListTh></DescriptionListTh>
            <DescriptionListTd>
              <AvisEditableListRowActions key={"rowActions"} {...props} />
            </DescriptionListTd>
          </>
        )}
      </DescriptionListTr>
    );

    const rows = fields.map((f) => (
      <DescriptionListTr key={f.name.toString()}>
        <DescriptionListTh>
          <AvisEditableListHeaderValue field={f} disabled={disabled} />
        </DescriptionListTh>
        <DescriptionListTd>
          <AvisEditableListRowField<P>
            {...props}
            key={f.name.toString()}
            field={f}
            rowIndex={props.index}
          />
        </DescriptionListTd>
      </DescriptionListTr>
    ));
    return [actionsRow, ...rows];
  };

  return (
    <DotsDescriptionListTable className={rowClassValue} gridLines="rows-only">
      <colgroup>
        <col
          style={{
            width: "50%",
          }}
        />
        <col
          style={{
            width: "50%",
          }}
        />
      </colgroup>
      <DescriptionListTBody>
        <DescriptionListTrExpander defaultVisibleRows={10}>
          {renderRow()}
        </DescriptionListTrExpander>
      </DescriptionListTBody>
    </DotsDescriptionListTable>
  );
}
